const amlKycBlacklistStyle = {
	
};

export default amlKycBlacklistStyle;
